// extracted by css-extract-rspack-plugin
export default {"wrapper":"_88f5d7cc","copy":"_565c851a","message":"_7bda1d94"};